import {
  useWorkToastStore,
  type WorkToastItem,
} from "@/stores/work-toast-store";

/** Every native worker carries a task id, so a discovery worker is told apart
 *  by what the user accepted: a worker of the onboarding project whose task
 *  the user did not choose. */
export function isDiscoveryWorkerToast(
  item: WorkToastItem,
  projectId: string,
  acceptedTaskIds: string[] = [],
): boolean {
  return (
    item.source === "native_worker" &&
    item.projectId === projectId &&
    !(item.taskId && acceptedTaskIds.includes(item.taskId))
  );
}

/** Discovery workers are observations, not the work the user chose. Once the
 *  user has decided, their toasts must not return in the tray panel. */
export function dismissDiscoveryWorkerToasts(
  projectId: string,
  acceptedTaskIds?: string[],
) {
  const { items, dismiss } = useWorkToastStore.getState();
  for (const item of Object.values(items))
    if (
      !item.dismissed &&
      isDiscoveryWorkerToast(item, projectId, acceptedTaskIds)
    )
      dismiss(item.key);
}
